if ( typeof ProductQuantity !== 'function' ) {

	class ProductQuantity extends HTMLElement {

		constructor(){
			super();

			this.qtyInput = this.querySelector('.qty-selector');
			this.qtyMinus = this.querySelector('.qty-minus');
			this.qtyPlus = this.querySelector('.qty-plus');
			if (!this.qtyInput) return;

			this.qtyMin = this.qtyInput.getAttribute('min') ? parseInt(this.qtyInput.getAttribute('min'), 10) : 1;
			this._productId = this.dataset.productId || this.closest('[data-js-product-component]')?.dataset?.id;
			this._alertHost = this.closest('product-form') || this.closest('[data-js-product-component]') || this;
			this._maxAllowed = null;

			this._updatePlusMinusState();
			this._bindBasicQtyControls();

			if (window.__krownGetProductQtyLimit?.(this._productId) != null) {
				this._initProductQtyLimit();
			}
		}

		_getEffectiveMax() {
			const attrMax = this.qtyInput.getAttribute('max');
			let max = attrMax ? parseInt(attrMax, 10) : 999;
			if (this._maxAllowed != null) {
				max = Math.min(max, this._maxAllowed);
			}
			return Number.isFinite(max) ? max : 999;
		}

		_updatePlusMinusState() {
			const currentQty = parseInt(this.qtyInput.value, 10) || this.qtyMin;
			const qtyMax = this._getEffectiveMax();

			if (currentQty - 1 < this.qtyMin) {
				this.qtyMinus?.classList.add('disabled');
			} else {
				this.qtyMinus?.classList.remove('disabled');
			}

			if (currentQty + 1 > qtyMax) {
				this.qtyPlus?.classList.add('disabled');
			} else {
				this.qtyPlus?.classList.remove('disabled');
			}
		}

		_enforceLimit(showAlert) {
			const qtyMax = this._getEffectiveMax();
			let currentQty = parseInt(this.qtyInput.value, 10);

			if (!Number.isFinite(currentQty) || currentQty < this.qtyMin) {
				this.qtyInput.value = this.qtyMin;
				currentQty = this.qtyMin;
			}

			if (currentQty > qtyMax) {
				this.qtyInput.value = qtyMax;
				if (showAlert) {
					window.__krownShowProductQtyLimitAlert?.(this._alertHost, this._productId);
				}
			}

			this._updatePlusMinusState();
		}

		_bindBasicQtyControls() {
			this.qtyInput.addEventListener('input', () => {
				this._enforceLimit(true);
			});

			this.qtyInput.addEventListener('change', () => {
				this._enforceLimit(true);
			});

			this.qtyMinus?.addEventListener('click', (e) => {
				e.preventDefault();
				if (this.qtyMinus.classList.contains('disabled')) return;
				const currentQty = parseInt(this.qtyInput.value, 10) || this.qtyMin;
				if (currentQty - 1 >= this.qtyMin) {
					this.qtyInput.value = currentQty - 1;
				}
				this._updatePlusMinusState();
			});

			this.qtyPlus?.addEventListener('click', (e) => {
				e.preventDefault();
				if (this.qtyPlus.classList.contains('disabled')) return;
				const currentQty = parseInt(this.qtyInput.value, 10) || this.qtyMin;
				const qtyMax = this._getEffectiveMax();
				if (currentQty + 1 <= qtyMax) {
					this.qtyInput.value = currentQty + 1;
				} else {
					window.__krownShowProductQtyLimitAlert?.(this._alertHost, this._productId);
				}
				this._updatePlusMinusState();
			});
		}

		async _refreshLimitFromCart() {
			if (!this._productId) return;

			const limit = window.__krownGetProductQtyLimit(this._productId);
			if (limit == null) return;

			const cartQty = await window.__krownFetchCartQtyForProduct(this._productId);
			this._maxAllowed = Math.max(0, limit - cartQty);

			if (this._maxAllowed <= 0) {
				this.qtyInput.setAttribute('max', '1');
				this.qtyInput.value = 1;
				this.qtyPlus?.classList.add('disabled');
				window.__krownShowProductQtyLimitAlert?.(this._alertHost, this._productId);
				return;
			}

			this.qtyInput.setAttribute('max', String(this._maxAllowed));
			this._enforceLimit(false);
		}

		_initProductQtyLimit() {
			this._refreshLimitFromCart();

			this._onCartChanged = () => {
				this._refreshLimitFromCart();
			};

			document.addEventListener('add-to-cart', this._onCartChanged);
			document.addEventListener('cart-updated', this._onCartChanged);
		}

		disconnectedCallback() {
			if (this._onCartChanged) {
				document.removeEventListener('add-to-cart', this._onCartChanged);
				document.removeEventListener('cart-updated', this._onCartChanged);
			}
		}
	}


  if ( typeof customElements.get('product-quantity') == 'undefined' ) {
    customElements.define('product-quantity', ProductQuantity);
	}

}
